import React from "react";

const AuthContext = React.createContext({
  authToken: null,
  signInWithEmailPassword: null,
  signInWithFacebook: null,
  signInWithGoogle: null,
  signOut: null,
  user: null,
  updateUserAndToken: null,
  updateToken: null,
  loadingUserInfo: null,
  updateUserInfo: null,
  handleLogin: null,
  loading: false,
});

export default AuthContext;
